export const menuConfig = {
  OVERVIEW: 1,
  SCOPED: 2,
  INAP: 3,
  DEALREVIEW: 4,
  LEGAL: 5,
  RM: 6,
  ADMIN: 7,
  RG:8
};

export const submenuConfig = {
  INAP: {
    DEFAULT: 0,
  },
  SCOPED: {
    DEFAULT: 0,
  },
  OVERVIEW: {
    DEFAULT: 0,
  },
  RM: { DASHBOARD: 101, PEOPLE: 102, PROJECTS: 103, RESOURCE: 104 },
  ADMIN: {
    DEFAULT: 0,
  },
  DEALREVIEW: {
    DEFAULT: 0,
  },
  LEGAL: {
    DEFAULT: 0,
  },
};

export const menuActionsConfig = {
  INAB: {
    CREATE_INAB_DEAL: "createINABDeal",
    REJECT_INAB_PROJECT: "INABDealReject",
    APPROVE_INAB_PROJECT: "INABDealApprove",
    SUBMIT_TO_RM_FROM_INAB: "submitToRMFromINAB",
  },
  SCOPED: {
    BEGIN_SCOPED_PROJECT: "beginScopedProject",
    SUBMIT_SCOPED_PROJECT: "submitScopedProject",
  },
};

export const actionNameConfig = {
  DEALREVIEW: {
    BEGIN_DEALREVIEW: "beginDealReview",
    // RESTART_DEALREVIEW: "restartDealReview", // not used
    ADD_ROLE_FOR_DEAL: "addRoleForDeal", // not used
    UPDATE_ROLE_FOR_DEAL: "updateRoleForDeal",
    DELETE_ROLE_FOR_DEAL: "deleteRoleForDeal",
    UPDATE_DISCOUNT_AND_EXPENSES: "updateDiscountAndExpenses",
    OVERVIEW_DETAILS_UPDATE: "overviewDetailsUpdate",
    REVIEW_DEALREVIEW: "reviewDealReview",
    REJECT_DEALREVIEW: "rejectDealReview",
    APPROVE_DEALREVIEW: "approveDealReview",
    UPDATE_QUESTIONARY_VALUES: "updateQuestionaryValues",
    SEND_DEAL_TO_LEGAL: "sendDealToLegalandRM",
    DR_DEAL_LOST: "drDealLost", // need to be added in DEALREVIEW
    ADDITIONAL_INFO_UPDATION_IN_DEALREVIEW: "additionInfoUpdationInDealReview",
    SEND_TO_QUESTIONARY: "sendToQuestionary",
    REMOVE_SOW: "removeSOW",
    APPROVED_RATECARD: "approveRateCard",
    REJECT_RATECARD: "rejectRateCard",
    IMPORT_PLAYGROUND_WORKBOOK: "importPlaygroundWorkbook"

  },
  SCOPED: {
    DEAL_NOTES_UPDATED: "dealNotesUpdated",
    BEGIN_SCOPED_PROJECT: "beginScopedProject",
    SUBMIT_SCOPED_PROJECT: "submitScopedProject",
    DELETE_ROLE_FROM_SCOPED_RESOURCE: "deleteRoleFromScopedResource",
    DEAL_RESOURCE_RM_NOTES_UPDATE: "dealResourceAndRMNotesUpdate",
    ADDITIONAL_INFO_UPDATION_IN_SCOPED: "additionInfoUpdationInScoped",
    ADD_DEAL_FROM_HUBSPOT: "addDealFromHubspot",
    PULL_UPDATED_DEALS_FROM_HUBSPOT: "pullUpdatedDealsFromHubspot",
  },

  INAB: {
    CREATE_INAB_DEAL: "createINABDeal",
    INAB_DEAL_REJECT: "INABDealReject",
    INAB_DEAL_APPROVE: "INABDealApprove",
    SUBMIT_TO_RM_FROM_INAB: "submitToRMFromINAB",
  },

  LEGAL: {
    BEGIN_LEGAL_REVIEW: "beginLegalReview",
    INFO_UPDATE_IN_SOW: "infoUpdateInSow",
    GENERATE_SOW: "generateSow",
    SEND_TO_VALIDATION: "sendToValidation",
    SEND_TO_REVIEW: "sendToReview",
    CUSTOMER_REVIEWED: "customerReviewed",
    CUSTOMER_APPROVED: "customerApproved",
    CUSTOMER_REJECTED: "customerRejected",
    SEND_TO_RM: "sendToRM",
    RE_OPEN_LEGAL_REVIEW: "reOpenLegalReview",
    RE_OPEN_DEAL_REVIEW: "reOpenDealReview",
    // DEAL_LOST:"dealLost", // need to removed
    LEGAL_DEAL_LOST: "legalDealLost", // need to be added in LEGAL
    UPLOAD_SOW: "uploadSow",
    SIGNED_SOW_UPLOAD: "signedSowUpload",
    SOW_APPROVED: "sowApproved",
    INITIAL_DRAFT: "intialDraft",
    UPLOAD_INITIAL_DRAFT: "uploadInitialDraft",
    CLIENT_ROUTE: "clientRoute",
    LEGAL_COMPLETE: "legalComplete",
    REMOVE_UPDATED_SOW: "removeInitialSow",
    REMOVE_SOW: "removeSignedSow",
  },

  RM: {
    PEOPLE: {
      EMPLOYEE_COMMIT_STATUS: "employeeCommitStatus",
      PROFILE: {
        ADD_NEW_CERTIFICATE: "addNewCertificate",
        ADD_NEW_SKILL: "addNewSkill",
        PROFILE_UPDATION: "profileUpdation",
        BENCH_NOTES_UPDATION: "benchNotesUpdation",
        PROBABILITYOF_EXTENSION: "probabilityExtension",
        COMMITMENT_CREATE: "commitmentCreate",
        COMMITMENT_UPDATE: "commitmentUpdate"
      },
    },
    PROJECTS:
    {
      UPDATE_DEAL_NOTE: "updateDealNote",
      END_DATE_CHANGE_FOR_RESOURCE: "endDateChangeForResource", // Not implement
      REMOVE_RESOURCE: "removeResource",
      UPLOAD_PROJECT_FILES: "uploadProjectFiles", //now no need to implement(future update)
      REPLACE_RESOURCE: "replaceResource", // not implement
      REMOVE_PROJECT_FILE: "removeProjectFile",
      NEW_REQUEST: "newRequest",
      REMOVE_REQUEST: "removeRequest",
      REPLACE_REQUEST: "replaceRequest",
      EXTEND_REQUEST: "extendRequest",
      CANCEL_REQUEST: "cancelRequest",
    },
    RESOURCE_ALLOCATION:
    {
      BEGIN_RESOURCE_ALLOCATION: "beginResourceAllocation",
      RESOURCE_ALLOCATION_COMPLETE: "resourceAllocationComplete",
      RESOURCE_ALLOCATION_PARTIALLY_COMPLETE: "resourceAllocationPartiallyComplete",
      RESOURCE_REJECT: "resourceReject",
      SUBMIT_REVIEWED_RESOURCES: "submitReviewedResources",
      RESOURCE_APPROVED: "resourceApproved",
      UPDATE_RESOURCE_ALLOCATION: "updateResourceAllocation",
    },
    DEMANDPIPELINE:
    {
      RESOURCE_UPDATE_ON_DEMAND: "resourceUpdateOnDemand",
      DEMAND_PIPELINE_COMPLETED: "demandPipelineCompleted",
      BEGIN_TO_DEMAND_PIPELINE: "beginToDemandPipeline",
      PROJECT_DEMAND_REJECT: "rejectRequest",
      PROJECT_DEMAND_EXTEND: "approveExtendRequest",
      PROJECT_DEMAND_REPLACE: "approveReplaceRequest",
      PROJECT_DEMAND_NEWADD: "approveNewAddRequest",
      PROJECT_DEMAND_REMOVE: "approveRemoveRequest"
    },
    // ADD_EMPLOYEE: "addEmployee" // need to removed

  },
  ADMIN: {
    USER_MANAGEMENT: {
      CREATE_GROUP: "createGroup",
      CREATE_USER: "createUser",
      CREATE_ROLE: "createRole",
      DELETE_ROLE: "deleteRole",
      UPDATE_USER: "updateUser",
      DELETE_USER: "deleteUser",
      DELETE_GROUP: "deleteGroup",
      UPDATE_ROLE: "updateRole",
      UPDATE_GROUP: "updateGroup",
    },
    NOTIFICATION: {
      ACTION_GROUP_UPDATION: "actionGroupUpdation",
    },
    ACCESS_POLICY: {
      POLICY_CREATION: "policyCreation",
      POLICY_UPDATION: "policyUpdation",
      POLICY_DELETION: "policyDeletion",
    },
    RATECARD: {
      RATE_CARD_UPDATION: "rateCardUpdation",
      RATE_CARD_DELETION: "rateCardDeletion",
      RATE_CARD_CREATION: "rateCardCreation",
    },
    SKILLSCERTIFICATES: {
      APPROVE_SKILLS: "approveSkills",
      APPROVE_CERTIFICATE: "approveCertificate",
      REJECT_SKILLS: "rejectSkills",
      REJECT_CERTIFICATE: "rejectCertificate"
    }
  },
  PLAYGROUND:{
    WORKSHEETSHARE:"workSheetShare",
    RENAMEWORKSHEET:"renameWorkSheet",
    DUPLICATEWORKSHEET:"duplicateWorkSheet",
    COPYSHEETPROJECT:"copySheetProject",
    ADDNEWSHEET:"addNewSheet",
    UPDATEPROJECTSHEET:"updateProjectSheet",
    PROJECTSHARE:"projectShare",
    ADD_RATE_CARD: "addRateCard",
    UPDATE_RATE_CARD: "updateRateCard"
  },
  MYPROFILE: {
    ADD_PROFILE_SKILL: "addProfileSkill",
    ADD_PROFILE_CERTIFICATE: "addProfileCertificate",
  },
};

export const SocketIdType = {
  EmployeeId: "employeeid", 
  ProjectId: "projectid", 
  INABID: "inabid" ,
  WorksheetId:"worksheetid",
  Playground: "playground",
  DemandId: "demandid"
}